import * as React from 'react';
import { ShowYoutubeSearchResults } from 'source/app/presentation/MainPanel/DevTools/Youtube/Search/Results/ShowYoutubeSearchResults';
import { FormInput } from 'source/app/presentation/Shared/Form/Input/FormInput';
import MotwLogicServer from 'source/app/services/External/LogicServer/MotwLogicServer';
import { IYoutubeSearchResult } from '../../../../../../../../motw_core/YouTube/IYoutubeSearchResult';

export function YoutubeSearch() {
	const [ searchText, setSearchText ] = React.useState('');

	const [ searchResults, setSearchResults ] = React.useState<
		IYoutubeSearchResult[]
	>([]);

	return (
		<div>
			<FormInput
				label="Search YouTube"
				onChange={(event) => setSearchText(event.target.value)}	
				type="text"
				maxWidth="80%"
				width="500px"
				value={searchText}
				onEnter={async () => {
					const searchResults = await MotwLogicServer.PostYoutubeSearchRequest(
						searchText
					);

					setSearchResults(searchResults);
					setSearchText('');
				}}
			/>
			<ShowYoutubeSearchResults searchResults={searchResults} />
		</div>
	);
}


